<!--
 * @Author: 仙道
 * @Date: 2022-08-20 16:08:44
 * @LastEditTime: 2023-08-16 11:01:33
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/components/AlertModal/index.vue
-->
<template>
  <j-modal
    :okButtonProps="{ class: { 'jee-hidden': true } }"
    :title="title"
    :visible="visible"
    :width="width"
    height="70%"
    @cancel="handleCancel"
    @ok="handleOk"
    cancelText="关闭"
    switchFullscreen
  >
    <a-table
      :columns="columns"
      :customRow="customRowRender"
      @change="handleTableChange"
      :dataSource="dataSource"
      :loading="loading"
      :pagination="ipagination"
      :scroll="{ x: true }"
      bordered
      class="j-table-force-wrap"
      ref="table"
      rowKey="id"
      size="middle"
    >
      <span slot="alertName" slot-scope="alertName, record">{{ record.devId_dictText }}</span>
      <template slot="imgSlot" slot-scope="text">
        <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
        <img
          :src="getImgView(text)"
          @click="previewFile(text)"
          alt
          height="25px"
          style="max-width:80px;font-size: 12px;font-style: italic;"
          v-else
        />
      </template>
      <span slot="summarySlot" slot-scope="text, record">
        <span style="margin-left:10px;">{{ text }}</span>
      </span>
      <span slot="levelSlot" slot-scope="text, record">
        <a-tag :color="$filterDictTextByCache('alert_level_color', text)">{{ record.alertLevel_dictText }}</a-tag>
      </span>
      <span slot="isAcknowledgementSlot" slot-scope="isAcknowledgement, record">
        <a-tag color="gray" v-if="record.isAcknowledgement == 0">未确认</a-tag>
        <a-tag color="#52c41a" v-else>已确认</a-tag>
      </span>
      <span slot="recoverySlot" slot-scope="isRecovery, record">
        <a-tag color="#ff4d4f" v-if="record.isRecovery == 0">未恢复</a-tag>
        <a-tag color="#52c41a" v-else>已恢复</a-tag>
      </span>
      <span slot="action" slot-scope="text, record">
        <a :disabled="!record.devId" @click="devDetail(record)">设备详情</a>
        <a-divider type="vertical" />
        <a :disabled="!record.pointCode" @click="dataLine(record)">数据曲线</a>
        <a-divider type="vertical" />
        <a @click="alertLife(record)">告警变化</a>
      </span>
    </a-table>

    <alert-life-cycle-modal ref="alertLifeModal"></alert-life-cycle-modal>
  </j-modal>
</template>

<script>
import PointsLineChartModal from '@views/monitor/datas/modules/PointsLineChartModal'
import AlertLifeCycleModal from '@views/monitor/alert/modules/AlertLifeCycleModal'
import moment from 'dayjs'
import { getAction } from '@/api/manage'
import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
export default {
  name: 'AlertModal',
  mixins: [JeecgListMixin],
  components: {
    PointsLineChartModal,
    AlertLifeCycleModal
  },

  data() {
    const forceNowrap = text => <span class="j-force-nowrap">{text}</span>
    return {
      title: '告警清单',
      width: '90%',
      visible: false,
      listUrl: '/alert/iotAlert/list',
      parms: {},
      // 表头
      columns: [
        {
          title: '告警名称',
          align: 'center',
          width: 180,
          scopedSlots: { customRender: 'alertName' }
        },
        {
          title: '告警时间',
          align: 'center',
          dataIndex: 'alertTime',
          width: 150,
          customRender: forceNowrap
        },
        {
          title: '告警信息',
          align: 'center',
          dataIndex: 'summary',
          align: 'left',
          scopedSlots: { customRender: 'summarySlot' }
        },
        {
          title: '告警等级',
          align: 'center',
          dataIndex: 'alertLevel',
          width: 100,
          scopedSlots: { customRender: 'levelSlot' }
        },
        {
          title: '是否确认',
          align: 'center',
          width: 100,
          dataIndex: 'isAcknowledgement',
          scopedSlots: { customRender: 'isAcknowledgementSlot' }
        },
        {
          title: '是否恢复',
          align: 'center',
          width: 100,
          dataIndex: 'isRecovery_dictText',
          scopedSlots: { customRender: 'recoverySlot' }
        },
        {
          title: '附件',
          align: 'center',
          width: 120,
          dataIndex: 'attachment',
          scopedSlots: { customRender: 'imgSlot' },
          sorter: true
        },
        {
          title: '处理方式',
          align: 'center',
          width: 100,
          dataIndex: 'disposal_dictText',
          customRender: forceNowrap
        },
        {
          title: '告警分类',
          align: 'center',
          width: 100,
          dataIndex: 'alertType_dictText',
          customRender: forceNowrap
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      dictOptions: {},
      superFieldList: [],
      disableMixinCreated: true
    }
  },
  methods: {
    show(listUrl, parms) {
      listUrl && (this.listUrl = listUrl)
      this.parms = parms
      this.loadData()
      this.visible = true
    },
    loadData() {
      // this.ipagination.current = 1
      var params = this.getQueryParams() // 查询条件

      getAction(this.listUrl, params)
        .then(res => {
          if (res.success) {
            this.dataSource = res.result.records || res.result
            if (res.result.total) {
              this.ipagination.total = res.result.total
            } else {
              this.ipagination.total = 0
            }
          } else {
            this.$message.warning(res.message)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    alertLife(record) {
      this.$refs.alertLifeModal.show(record.id)
    },
    close() {
      this.$emit('ok')
      this.visible = false
    },
    handleOk() {},
    submitCallback(id = '') {
      this.$emit('ok', id)
      this.visible = false
    },
    handleCancel() {
      this.close()
    }
  }
}
</script>
